/** Cont file */
//public variables and secret keys
import moment from "moment-timezone";
let documentTitle = "Attorney Application";
let API_BASE = "https://devapi.uslegalservices.net/api/attorney_portal/";
let CLAIM_BASE = "https://devapi.uslegalservices.net/api/attorney_claims/v2/";
let SHARP_SPRINT_API_BASE = "https://api.sharpspring.com/pubapi/v1";
let ACCOUNT_ID = "E2950B5EB0007D1A608B404B35FA64F0";
let SECRET_KEY = "7B7D88D06C6071E779EC7F6B2A76D2CC";
let MS_BASE = "https://devms.uslegalservices.net/usl";
// let ATT_BASE = "http://devattny.uslegalservices.net/";
let ATT_BASE = "https://devattportal.uslegalservices.net";
let BASE_S3 = "https://uslawstests3.s3.amazonaws.com";
/**
 * @OLD_DOMAIN
 * http://devattny.uslegalservices.net
 * @NEW_DOMAIN_GIVEN_BY_RAJIV_DT_28_NOV_23
 * https://devattportal.uslegalservices.net
 * @TEMP_DOMAIN
 * https://devagentportal.uslegalservices.net
 */
if (
  window.location.origin != "https://devattportal.uslegalservices.net" &&
  window.location.origin != "http://localhost:8080"
) {
  API_BASE = "https://api.uslegalservices.net/api/attorney_portal/";
  CLAIM_BASE = "https://api.uslegalservices.net/api/attorney_claims/v2/";
  MS_BASE = "https://usl.uslegalservices.net/usl";
  ATT_BASE = "https://attorney.uslegalservices.net/";
}

const setDateFormat = date => {
  if (date != null && date != "" && date != "0000-00-00 00:00:00") {
    return moment(date).format("MM/DD/YYYY");
  } else if (date == "0000-00-00 00:00:00") {
    return "";
  }
};
export default {
  setDateFormat,
  documentTitle,
  API_BASE,
  CLAIM_BASE,
  SHARP_SPRINT_API_BASE,
  ACCOUNT_ID,
  SECRET_KEY,
  MS_BASE,
  ATT_BASE,
  BASE_S3
};
